import React from "react";
import { IconName, icons } from "./icons";

interface IconProps {
  name: IconName;
  size?: number;
  color?: string;
  className?: string;
}

const Icon: React.FC<IconProps> = ({ name, size = 24, color, className }) => {
  const SvgIcon = icons[name]; // React component

  const classes = [className, color ? `text-${color}` : ""]
    .filter(Boolean)
    .join(" ");

  // Use default viewBox, or allow override if needed
  //   const viewBox = "0 0 24 24";

  // Fallback if icon name is invalid or not found
  // if (!SvgIcon || typeof SvgIcon !== 'function') {
  //     console.warn(`Icon "${name}" not found in icons map.`);
  //     return (
  //         <span
  //             style={{
  //                 display: 'inline-block',
  //                 width: size,
  //                 height: size,
  //                 background: '#ffcdd2',
  //                 color: '#b71c1c',
  //                 textAlign: 'center',
  //                 lineHeight: `${size}px`,
  //                 borderRadius: '4px',
  //                 fontWeight: 'bold',
  //                 border: '1px solid #b71c1c',
  //             }}
  //             className={classes}
  //             title={`Icon "${name}" not found`}
  //         >
  //             ?
  //         </span>
  //     );
  // }

  // Pass fill prop for color if needed
  return (
    <SvgIcon
      width={size}
      height={size}
      // viewBox={viewBox}
      className={classes}
      {...(color ? { fill: color } : {})}
    />
  );
};

export default Icon;
export type { IconName };

